import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, styles, Typography } from '../index';
import { animated, useSpring } from "react-spring";
import classnames from 'classnames';

const InlineLoading = props => {
  const classes = useStyles();
  const theme = styles.useTheme();
  const [ reverse, setReverse ] = React.useState(false);

  const springStyle = useSpring({ opacity: props.loading ? 1 : 0 });
  const textStyle = useSpring({
    to: { opacity: 1, color: theme.palette.primary.main },
    from: { opacity: 0.5, color: theme.palette.primary.main },
    reset: reverse,
    reverse,
    duration: 10000
  });
  if (!props.loading) return null;

  return (
    <animated.div className={classnames(classes.root, props.containerClass)} style={springStyle}>
      <CircularProgress size={20} variant={'indeterminate'} className={props.loadingIconClass}/>
      {
        !!props.loadingText && (
          <animated.div className={classes.text} style={textStyle}>
            <Typography variant={'caption'} className={props.loadingTextClass}>{ props.loadingText }</Typography>
          </animated.div>
        )
      }
    </animated.div>
  );
};

InlineLoading.propTypes = {
  loading: PropTypes.bool.isRequired,
  loadingText: PropTypes.string,
  loadingIconClass: PropTypes.string,
  loadingTextClass: PropTypes.string,
  containerClass: PropTypes.string,
};

const useStyles = styles.makeStyles(theme => ({
  root: {
    flex: 1,
    zIndex: 5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 400ms',
    padding: theme.spacing(4),
  },
  text: {
    marginTop: theme.spacing(2)
  }
}));

export default InlineLoading;
